import Typography from 'ui/src/components/Typography'
import { useTranslation } from 'react-i18next'
import { format } from 'date-fns'
import { fr, enUS } from 'date-fns/locale'
import { SwitchReportedImageContent } from './switchReportedImageContent'
import {
  MonitorIcon,
  LockIcon,
  FmdGoodIcon,
  KeyIcon,
  GppGoodIcon,
  ImageIcon,
  PersonIcon,
  PhoneIcon,
  LabelImportantIcon,
  AssignmentIcon,
  ErrorIcon,
  ReportProblemIcon,
} from 'ui/src/assets/icons/'

export const SwitchNotificationType = (
  type: string,
  leakCount?: number,
  scanDate?: string,
  scoreDifference?: number,
  notificationScore?: number,
  score?: number,
  status?: string,
  img?: string,
) => {
  const { i18n, t } = useTranslation()

  const roundedScoreDiff =
    scoreDifference !== undefined && scoreDifference > 0
      ? Math.floor(scoreDifference)
      : scoreDifference !== undefined
        ? Math.ceil(scoreDifference)
        : undefined
  const reportStatusTitle = SwitchReportedImageContent(status).title
  const reportStatusDescription = SwitchReportedImageContent(status).description
  const scoreDate =
    scanDate &&
    format(new Date(scanDate || ''), 'LL/dd/yyyy HH:mm', {
      locale: i18n.language === 'fr-FR' || i18n.language === 'fr-CA' ? fr : enUS,
    })

  const notificationObject = {
    title: <div />,
    description: <div />,
    icon: <div />,
  }

  const CompanyScoreInfomation = (score: number): string => {
    const scoreMap = [
      { limit: 0, grade: '-' },
      { limit: 400, grade: 'F' },
      { limit: 600, grade: 'E' },
      { limit: 700, grade: 'D' },
      { limit: 800, grade: 'C' },
      { limit: 900, grade: 'B' },
      { limit: 1001, grade: 'A' },
    ]

    const foundScore = scoreMap.find(({ limit }) => score < limit)
    return foundScore ? foundScore.grade : ''
  }

  const companyScore = notificationScore && CompanyScoreInfomation(notificationScore)

  switch (type) {
    case 'DOMAIN':
      notificationObject.title = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 'h7Str.fontSize',
            fontWeight: 'h7Str.fontWeight',
          }}
        >
          {t('notifications.domainNotification.title')}
        </Typography>
      )
      notificationObject.description = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 14,
            lineHeight: 1.31,
          }}
        >
          <Typography
            component={'span'}
            sx={{
              fontWeight: 500,
            }}
          >
            {leakCount}
          </Typography>
          {t('notifications.domainNotification.description')}
        </Typography>
      )
      notificationObject.icon = (
        <MonitorIcon
          sx={{ position: 'absolute', top: 15, size: 3, color: '#E599A9', ml: 0.5, mr: 3 }}
        />
      )
      break
    case 'PASSWORD':
      notificationObject.title = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 'h7Str.fontSize',
            fontWeight: 'h7Str.fontWeight',
          }}
        >
          {t('notifications.passwordNotification.title')}
        </Typography>
      )
      notificationObject.description = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 14,
            lineHeight: 1.31,
          }}
        >
          {t('notifications.passwordNotification.description.0')}
          <Typography
            component={'span'}
            sx={{
              fontWeight: 500,
            }}
          >
            {leakCount}
          </Typography>
          {t('notifications.passwordNotification.description.1')}
        </Typography>
      )
      notificationObject.icon = (
        <LockIcon
          sx={{ position: 'absolute', top: 15, size: 3, color: '#E599A9', ml: 0.5, mr: 3 }}
        />
      )
      break
    case 'ADDRESS':
      notificationObject.title = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 'h7Str.fontSize',
            fontWeight: 'h7Str.fontWeight',
          }}
        >
          {t('notifications.adressNotification.title')}
        </Typography>
      )
      notificationObject.description = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 14,
            lineHeight: 1.31,
          }}
        >
          {t('notifications.adressNotification.description.0')}
          <Typography
            component={'span'}
            sx={{
              fontWeight: 500,
            }}
          >
            {leakCount}
          </Typography>
          {t('notifications.adressNotification.description.1')}
        </Typography>
      )
      notificationObject.icon = (
        <FmdGoodIcon
          sx={{ position: 'absolute', top: 15, size: 3, color: '#E599A9', ml: 0.5, mr: 3 }}
        />
      )
      break
    case 'MFA':
      notificationObject.title = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 'h7Str.fontSize',
            fontWeight: 'h7Str.fontWeight',
          }}
        >
          {t('notifications.mfaNotification.title')}
        </Typography>
      )
      notificationObject.description = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 14,
            lineHeight: 1.31,
          }}
        >
          {t('notifications.mfaNotification.description')}
        </Typography>
      )
      notificationObject.icon = (
        <KeyIcon
          sx={{ position: 'absolute', top: 15, size: 3, color: '#E599A9', ml: 0.5, mr: 3 }}
        />
      )
      break
    case 'SCORE':
      notificationObject.title = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 'h7Str.fontSize',
            fontWeight: 'h7Str.fontWeight',
          }}
        >
          {notificationScore
            ? t('notifications.scoreNotification.title', { score: notificationScore })
            : t('notifications.scoreNotification.titleDefault')}
        </Typography>
      )
      notificationObject.description = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 14,
            lineHeight: 1.31,
          }}
        >
          {t('notifications.scoreNotification.description.0')}
          {scoreDate && scoreDate}
          {scoreDifference && scoreDifference > 0
            ? t('notifications.scoreNotification.description.1')
            : t('notifications.scoreNotification.description.2')}
          {roundedScoreDiff && Math.abs(roundedScoreDiff)}
          {t('notifications.scoreNotification.description.3')}
        </Typography>
      )
      notificationObject.icon = (
        <GppGoodIcon
          sx={{ position: 'absolute', top: 15, size: 3, color: '#99C4F9', ml: 0.5, mr: 3 }}
        />
      )
      break
    case 'SAFE':
      notificationObject.title = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 'h7Str.fontSize',
            fontWeight: 'h7Str.fontWeight',
          }}
        >
          {t('notifications.safeNotification.title')}
        </Typography>
      )
      notificationObject.description = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 14,
            lineHeight: 1.31,
          }}
        >
          {t('notifications.safeNotification.description.0')}
          <Typography
            component={'span'}
            sx={{
              fontWeight: 500,
            }}
          >
            {t('notifications.safeNotification.description.1')}
          </Typography>
          {t('notifications.safeNotification.description.2')}
          {scoreDate && scoreDate}
          {t('notifications.safeNotification.description.3')}
        </Typography>
      )
      notificationObject.icon = (
        <GppGoodIcon
          sx={{ position: 'absolute', top: 15, size: 3, color: '#99C4F9', ml: 0.5, mr: 3 }}
        />
      )
      break
    case 'IMAGE':
      notificationObject.title = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 'h7Str.fontSize',
            fontWeight: 'h7Str.fontWeight',
          }}
        >
          {t('notifications.imageNotification.title')}
        </Typography>
      )
      notificationObject.description = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 14,
            lineHeight: 1.31,
          }}
        >
          {t('notifications.imageNotification.description')}
        </Typography>
      )
      notificationObject.icon = (
        <ImageIcon
          sx={{ position: 'absolute', top: 15, size: 3, color: '#CCAB004D', ml: 0.5, mr: 3 }}
        />
      )
      break
    case 'NAME':
      notificationObject.title = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 'h7Str.fontSize',
            fontWeight: 'h7Str.fontWeight',
          }}
        >
          {t('notifications.nameNotification.title')}
        </Typography>
      )
      notificationObject.description = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 14,
            lineHeight: 1.31,
          }}
        >
          {t('notifications.nameNotification.description.0')}
          <Typography
            component={'span'}
            sx={{
              fontWeight: 500,
            }}
          >
            {leakCount}
          </Typography>
          {t('notifications.nameNotification.description.1')}
        </Typography>
      )
      notificationObject.icon = (
        <PersonIcon
          sx={{ position: 'absolute', top: 15, size: 3, color: '#CCAB004D', ml: 0.5, mr: 3 }}
        />
      )
      break
    case 'PHONE':
      notificationObject.title = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 'h7Str.fontSize',
            fontWeight: 'h7Str.fontWeight',
          }}
        >
          {t('notifications.phoneNotification.title')}
        </Typography>
      )
      notificationObject.description = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 14,
            lineHeight: 1.31,
          }}
        >
          {t('notifications.phoneNotification.description.0')}
          <Typography
            component={'span'}
            sx={{
              fontWeight: 500,
            }}
          >
            {leakCount}
          </Typography>
          {t('notifications.phoneNotification.description.1')}
        </Typography>
      )
      notificationObject.icon = (
        <PhoneIcon
          sx={{ position: 'absolute', top: 15, size: 3, color: '#CCAB004D', ml: 0.5, mr: 3 }}
        />
      )
      break
    case 'OTHER':
      notificationObject.title = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 'h7Str.fontSize',
            fontWeight: 'h7Str.fontWeight',
          }}
        >
          {t('notifications.otherNotification.title')}
        </Typography>
      )
      notificationObject.description = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 14,
            lineHeight: 1.31,
          }}
        >
          {t('notifications.otherNotification.description.0')}
          <Typography
            component={'span'}
            sx={{
              fontWeight: 500,
            }}
          >
            {leakCount}
            {t('notifications.otherNotification.description.1')}
          </Typography>
          {t('notifications.otherNotification.description.2')}
        </Typography>
      )
      notificationObject.icon = (
        <LabelImportantIcon
          sx={{ position: 'absolute', top: 15, size: 3, color: '#CCAB004D', ml: 0.5, mr: 3 }}
        />
      )
      break
    case 'REPORT_STATUS':
      notificationObject.title = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 'h7Str.fontSize',
            fontWeight: 'h7Str.fontWeight',
          }}
        >
          {reportStatusTitle}
        </Typography>
      )
      notificationObject.description = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 14,
            lineHeight: 1.31,
          }}
        >
          {reportStatusDescription}
        </Typography>
      )
      notificationObject.icon = (
        <img
          style={{
            position: 'absolute',
            top: 5,
            width: 24,
            height: 24,
            marginLeft: 4,
            marginRight: 24,
          }}
          src={img}
        />
      )

      break
    case 'RESPONSE_PLAN':
      notificationObject.title = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 'h7Str.fontSize',
            fontWeight: 'h7Str.fontWeight',
          }}
        >
          {t('notifications.responsePlanNotification.title')}
        </Typography>
      )
      notificationObject.description = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 14,
            lineHeight: 1.31,
          }}
        >
          {t('notifications.responsePlanNotification.description')}
        </Typography>
      )
      notificationObject.icon = (
        <AssignmentIcon
          sx={{ position: 'absolute', top: 15, size: 3, color: '#99C4F9', ml: 0.5, mr: 3 }}
        />
      )
      break
    case 'UNRESOLVED':
      notificationObject.title = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 'h7Str.fontSize',
            fontWeight: 'h7Str.fontWeight',
          }}
        >
          {t('notifications.unresolvedNotification.title')}
        </Typography>
      )
      notificationObject.description = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 14,
            lineHeight: 1.31,
          }}
        >
          {t('notifications.unresolvedNotification.description')}
        </Typography>
      )
      notificationObject.icon = (
        <ErrorIcon
          sx={{ position: 'absolute', top: 15, size: 3, color: '#CCAB004D', ml: 0.5, mr: 3 }}
        />
      )
      break
    case 'COMPANY_SCORE':
      notificationObject.title = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 'h7Str.fontSize',
            fontWeight: 'h7Str.fontWeight',
          }}
        >
          {t('notifications.companyScoreNotification.title')}
          {companyScore && companyScore}
        </Typography>
      )
      notificationObject.description = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 14,
            lineHeight: 1.31,
          }}
        >
          {t('notifications.companyScoreNotification.description.0')}
          {scoreDate && scoreDate}
          {t('notifications.companyScoreNotification.description.1')}
          <Typography
            component={'span'}
            sx={{
              fontWeight: 500,
            }}
          >
            {scoreDifference !== undefined && scoreDifference > 0
              ? t('notifications.companyScoreNotification.description.2')
              : t('notifications.companyScoreNotification.description.3')}
            {roundedScoreDiff !== undefined && Math.abs(roundedScoreDiff)}
          </Typography>
          {t('notifications.companyScoreNotification.description.4')}
        </Typography>
      )
      notificationObject.icon = (
        <GppGoodIcon
          sx={{ position: 'absolute', top: 15, size: 3, color: '#99C4F9', ml: 0.5, mr: 3 }}
        />
      )
      break
    case 'COMPANY_UPDATES':
      notificationObject.title = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 'h7Str.fontSize',
            fontWeight: 'h7Str.fontWeight',
          }}
        >
          {t('notifications.companyUpdatesNotification.title')}
        </Typography>
      )
      notificationObject.description = (
        <Typography
          sx={{
            color: 'gray.900',
            fontSize: 14,
            lineHeight: 1.31,
          }}
        >
          {t('notifications.companyUpdatesNotification.description')}
        </Typography>
      )
      notificationObject.icon = (
        <ReportProblemIcon
          sx={{ position: 'absolute', top: 15, size: 3, color: '#CCAB004D', ml: 0.5, mr: 3 }}
        />
      )
      break

    default:
      break
  }

  return notificationObject
}
